import { mapState } from 'vuex';
import Dialog from 'kpc/components/dialog';
import {Select, Option} from 'kpc/components/select';
import Form from 'kpc/components/form';
import Input from 'kpc/components/input';
import {Table, TableColumn} from 'kpc/components/table';
import Tooltip from 'kpc/components/tooltip';
import Button from 'kpc/components/button';
import Icon from 'kpc/components/icon';
import * as commonConst from '../../../store/common/constants';
export default{
    props:{
        orderBills:{
            type:Array,
            default:() => [],
            required: true
        },
        soldoutList:{
            type:Array,
            default:() => [],
            required: true
        }
    },
    components:{
        Dialog,
        Select,
        Option,
        Form,
        Input,
        Table,
        TableColumn,
        Tooltip,
        Button,
        Icon
    },
    computed: {
        ...mapState({
            pcommon: state => state.__pbc__.common,
        }),
    },
    data(){
        return{
            newOrderBills:[],
            cpuList:[],
            memList:[],
            kecList:[],
            azShow:false,
            billType: 1,  //默认 包年包月
            cpuNum:'',
            memNum:'',
            packageCode:'',
            isSearchCode:false,
            isReset:false,
            chooseData:{}
        }
    },
    watch:{
        billType(){
            if(this.packageCode){
                this.searchPackageCode()
            }
            if(!this.isSearchCode){
                this.getCPU()
            }
        },
        packageCode(val){
            if(!val && this.isReset){
                this.searchPackageCode()
            }

        },
        cpuNum(){
            if(!this.isSearchCode){
                this.packageCode = ''
                this.getMem()
            }
        },
        memNum(){
            if(!this.isSearchCode){
                this.packageCode = ''
                this.getKecList()
            }
        },
        kecList(val){
            //可用区套餐售罄判断
            _.forEach(this.soldoutList,soldItem =>  {
                _.forEach(val,kecItem => {
                    if(soldItem.ProductType === kecItem.productTypeId){
                        let obj = _.find(soldItem.PackageSellOuts,packageItem => packageItem.PackageCode === kecItem.packageCode)
                        if(obj){
                            _.forEach(kecItem.areaList,areaItem => {
                                if(_.includes(soldItem.AvailabilityZone,areaItem.regionCode)){
                                    _.forEach(areaItem.azList,azItem => {
                                        if(soldItem.AvailabilityZone === azItem.azCode){
                                            azItem.isSlodOut = true
                                        }
                                    })
                                }
                            })
                        }
                    }
                })
            })

        }
    },
    methods:{
        close(){
            this.reset()
        },
        goPurchase(kec,indexs,index){
            this.azShow = false
            let obj = kec.areaList[indexs].azList[index].data[0]
            // obj.cpu = this.cpuNum
            // obj.mem = this.memNum
            // if(this.chooseData.kecKey !== obj.kecKey){


                if(this.chooseData.azCode === obj.azCode){
                    obj.isSameAzCode = true
                }
                if(this.chooseData.cpu === obj.cpu){
                    obj.isSameCpu = true
                }
                this.chooseData = obj
                this.$emit('closeAzSearchDia',obj)




            // }
            this.reset()
        },
        start(){
            this.azShow = true
            let orderBills = _.cloneDeep(this.orderBills)
            orderBills = _.sortBy(orderBills,o => o.billTypeId)
                            .map(item => {
                                delete item.regions
                                return item
                            })
            this.newOrderBills = this.handleData(orderBills)
            this.getCPU()
        },
        handleData(data){
            let list = _.cloneDeep(data)

            _.forEach(list,billTypeItem => {
                billTypeItem.cpuList = [];
                let arr = []
                _.forEach(billTypeItem.data,item => {
                    let cpu = (_.find(item.packageInfo, pitem=>{
                        return pitem.propCode.toLowerCase() == "cpu"})||{}).propValue[0].max
                        if(!_.includes(arr,cpu)){
                            arr.push(cpu)
                        }
                })
                arr = arr.sort((a,b) => a - b)
                arr.unshift(this.$trans(`全部`))

                _.forEach(arr,cpuNum => {
                    let cpuobj = {}
                    if(cpuNum === this.$trans(`全部`)){
                        cpuobj.cpu_num = cpuNum
                        cpuobj.data = billTypeItem.data;
                    } else {
                        cpuobj.cpu_num = cpuNum
                        cpuobj.data = [];
                        _.forEach(billTypeItem.data,kecitem => {
                            let cpu = (_.find(kecitem.packageInfo, pitem=>{
                                return pitem.propCode.toLowerCase() == "cpu"})||{}).propValue[0].max
                            if(cpu == cpuNum){
                                cpuobj.data.push(kecitem)
                            }

                        })
                    }
                    billTypeItem.cpuList.push(cpuobj)
                })
            })
            _.each(list,billTypeItem =>{
                _.forEach(billTypeItem.cpuList,cpuItem => {
                    let  memSet = new Set();
                    _.forEach(cpuItem.data, kecitem=>{
                        let mem =  (_.find(kecitem.packageInfo, pitem=>{
                            return pitem.propCode == "mem"})||{}).propValue[0].max
                        memSet.add(mem);
                    })
                    memSet = [...memSet].sort((a, b) => {
                        return a - b;
                    });
                    memSet = [this.$trans(`全部`)].concat(memSet);

                    cpuItem.memList=[]
                    _.forEach(memSet,memNum =>{
                        let memobj ={}
                        if(memNum == this.$trans(`全部`)){
                            memobj.mem = this.$trans(`全部`);
                            memobj.data = cpuItem.data
                        }else{
                            memobj.mem = memNum;
                            memobj.data = []
                            _.forEach(cpuItem.data,kecItem=>{
                                let mem = (_.find(kecItem.packageInfo, pitem=>{
                                    return pitem.propCode == "mem"})||{}).propValue[0].max;
                                if(mem == memNum){
                                    memobj.data.push(kecItem)
                                }
                            })
                        }
                        cpuItem.memList.push(memobj)
                    })

                })
            })


            _.each(list,billTypeItem =>{
                _.forEach(billTypeItem.cpuList,cpuItem => {
                    _.forEach(cpuItem.memList,memItem => {
                        let arr = []
                        _.forEach(memItem.data,item => {
                            if(!_.find(arr,o => o.packageCode === item.packageCode && o.cpu === item.cpu && o.mem === item.mem && o.productTypeId === item.productTypeId)){
                                arr.push({
                                    generation:item.generation,
                                    productTypeId:item.productTypeId,
                                    productTypeName:item.productTypeName,
                                    packageCode:item.packageCode,
                                    cpu:item.cpu,
                                    mem:item.mem,
                                    kecKey:item.kecKey
                                })
                            }
                        })
                        memItem.kecList = []
                        _.forEach(arr,item => {
                            item.data = []
                            _.forEach(memItem.data,i => {
                                if((item.packageCode === i.packageCode && item.cpu === i.cpu && item.mem === i.mem && item.productTypeId === i.productTypeId)){
                                    item.data.push(i)
                                }
                            })
                        })
                        memItem.kecList = arr
                    })
                })
            })
            _.each(list,billTypeItem =>{
                _.forEach(billTypeItem.cpuList,cpuItem => {
                    _.forEach(cpuItem.memList,memItem => {
                        _.forEach(memItem.kecList,listItem => {
                            let arr = []
                            _.forEach(listItem.data,item => {
                                if(!_.find(arr, o => o.regionCode === item.regionCode)){
                                    arr.push({
                                        regionCode:item.regionCode,
                                        regionName:item.regionName
                                    })
                                }
                            })
                            _.forEach(arr,item => {
                                item.data = []
                                _.forEach(listItem.data,i => {
                                    if((item.regionCode === i.regionCode)){
                                        item.data.push(i)
                                    }
                                })

                            })
                            listItem.areaList = arr
                        })
                    })
                })
            })
            _.each(list,billTypeItem =>{
                _.forEach(billTypeItem.cpuList,cpuItem => {
                    _.forEach(cpuItem.memList,memItem => {
                        _.forEach(memItem.kecList,listItem => {
                            _.forEach(listItem.areaList,areaItem => {
                                let arr = []
                                _.forEach(areaItem.data,item => {
                                    if(!_.find(arr,o => o.regionCode === item.azCode)){
                                        arr.push({
                                            azCode:item.azCode,
                                            azName:item.azName
                                        })
                                    }
                                })
                                _.forEach(arr,item => {
                                    item.data = []
                                    _.forEach(areaItem.data,i=>{
                                        if(item.azCode === i.azCode){
                                            item.data.push(i)
                                        }
                                    })
                                })

                                areaItem.azList = arr
                            })
                        })
                    })
                })
            })
            return list
        },
        getCPU(){
            let {cpuList} = _.find(this.newOrderBills,o => o.billTypeId === this.billType)
            this.cpuList = cpuList
            let exit = false
            if(_.find(cpuList,o => o.cpu_num === this.cpuNum)){
                exit = true
            }
            if(!exit || this.isReset){
                this.cpuNum = this.cpuList[0].cpu_num
            }
            this.getMem()
        },
        getMem(){
            let {memList} = _.find(this.cpuList,o => o.cpu_num === this.cpuNum)
            this.memList = memList
            let exit = false
            if(_.find(memList,o => o.mem === this.memNum)){
                exit = true
            }
            if(!exit || this.isReset){
                this.memNum = this.memList[0].mem
            }
            this.getKecList()
        },
        getKecList(){
            let {kecList} = _.find(this.memList,o => o.mem === this.memNum)
            this.kecList = this.sortKecList(kecList)
        },
        searchPackageCode(){
            this.isSearchCode = true
            this.cpuNum = this.cpuList[0].cpu_num
            this.memNum = this.memList[0].mem
            let {cpuList} = _.find(this.newOrderBills,o => o.billTypeId === this.billType)
            let {memList} = _.find(cpuList,o => o.cpu_num === this.cpuNum)
            let {kecList} = _.find(memList,o => o.mem === this.memNum)
            kecList = this.sortKecList(kecList)
            if(this.packageCode){
                let list = _.filter(kecList,o=> o.packageCode === this.packageCode)
                this.kecList = list
            } else {
                this.kecList = kecList
            }

            this.$nextTick(() => {
                this.isSearchCode = false
            })

        },
        sortKecList(kecList){
            let map = new Map();
            map.set('4', 4);
            map.set('3', 3);
            map.set('2', 2);
            map.set('1', 1);
            map.set("ARM", 0);
            map.set("gpu", -1);
            map.set("container instance", -2)
            kecList = kecList.sort((a, b) => {
                return map.get(b.generation) - map.get(a.generation)
            })

            // 按照系列从大到小排列，GPU机型排在最后面
            let kecDataList = _.filter(kecList, (item) => {
                return _.toNumber(item.generation);
            });
            let gpuDataList = _.filter(kecList, (item) => {
                return !_.toNumber(item.generation);
            });
            kecDataList = _.orderBy(kecDataList, ['generation', 'cpu', 'mem'], ['desc', 'asc', 'asc']); //非GPU机型排序 优先级：系列 > CPU > 内存
            gpuDataList = _.orderBy(gpuDataList, ['generation', 'cpu', 'mem'], ['desc', 'asc', 'asc']); //GPU机型排序 优先级：系列 > CPU > 内存
            kecList = kecDataList.concat(gpuDataList);

            // 相同机型数据按照固定顺序集合在一起;
            let _kecList = [];
            let otherKecType = _.filter(kecList, (item) => {
                return !commonConst.allKecTypeDefaultSort(item.productTypeId)
            });
            _.forEach(commonConst.allKecTypeDefaultSortCodes, (item) => {
                let tempKecList = [];
                _.forEach(kecList, (subItem) => {
                    if (item == subItem.productTypeId) {
                        tempKecList.push(subItem);
                    }
                });
                _kecList = _kecList.concat(tempKecList);
            });
            kecList = _kecList.concat(otherKecType);

            return kecList
        },
        reset(){
            this.isReset = true
            this.packageCode = ''
            this.billType = 1
            this.cpuNum = this.cpuList[0].cpu_num
            this.memNum = this.memList[0].mem
            this.$nextTick(() => {
                this.isReset = false
            })
        }
    }
}
